<template>
  <div class="mall-recharge">
    <div class="page-section" style="border-top: none">
      <el-form class="page-search__form" ref="searchForm" :model="listInfo">
        <div class="page-search__item" v-if="listInfo.recordType == 1">
          <el-form-item>
            <el-select :placeholder="$t('common.type')" clearable filterable v-model="listInfo.type">
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in mallRechargeTypeDict"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__item" v-else-if="listInfo.recordType == 2">
          <el-form-item>
            <el-select :placeholder="$t('common.type')" clearable filterable v-model="listInfo.type">
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in mallExpenditureTypeDict"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__item" v-else>
          <el-form-item>
            <el-select :placeholder="$t('common.type')" clearable filterable v-model="listInfo.type">
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in mallExpenditureTypeDict"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
              <el-option
                v-for="item in mallRechargeTypeDict"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="page-search__item">
          <el-form-item>
            <el-select
              :placeholder="$t('common.incomeExpenseType')"
              clearable
              filterable
              v-model="listInfo.recordType"
            >
              <el-option :label="$t('common.income')" :value="1"></el-option>
              <el-option :label="$t('common.expense')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__item page-search__item_large">
          <el-form-item>
            <el-date-picker
              :clearable="false"
              v-model="listInfo.date"
              :default-time="['00:00:00', '23:59:59']"
              unlink-panels
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('common.to')"
              :start-placeholder="$t('common.dateStart')"
              :end-placeholder="$t('common.dateEnd')"
              :picker-options="pickerOptions"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="page-search__item page-search__item_flex">
          <el-button
            type="primary"
            class="page-button_medium"
            @click="getMallFinancialData()"
            >{{ $t('common.search') }}</el-button
          >
          <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </div>
      </el-form>
    </div>
    <div class="page-section">
      <div class="page-table" v-if="tableHeight > 0">
        <div style="display: flex; display: flex; justify-content: end">
          <el-button
            type="primary"
            class="page-button_medium page-button_blue"
            :loading="downloadLoading"
            @click="download"
            >{{ $t('common.exportDetail') }}</el-button
          >
        </div>

        <el-table
          :data="listData"
          :max-height="tableHeight + 'px'"
          v-loading="listLoading"
          :element-loading-text="$t('common.loading')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column :label="$t('common.type')" min-width="140px">
            {{ index }}
            <template slot-scope="{ row }">
              <span>{{ getTypeName(row) }}</span>
              <!-- <span v-else-if="row.serviceType !=501 && index!='recharge' ">{{ getTypeName(row) }}</span>
              <span v-else>订单消费</span> -->
            </template>
            <!-- <template slot-scope="{ row }" v-else>
              <span>点券消费</span>
            </template> -->
          </el-table-column>
          <el-table-column :label="$t('common.time')" min-width="100px">
            <template slot-scope="{ row }">
              <span>{{ row.gmtCreate.split(" ")[0] }}</span>
              <br />
              <span>{{ row.gmtCreate.split(" ")[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.incomeExpenseType')" min-width="100px">
            <template slot-scope="{ row }">
              <span>{{ row.recordType == 1 ? $t('common.income') : $t('common.expense') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('common.amountWithYuan')"
            min-width="100px"
            :formatter="formatToYuan"
          ></el-table-column>
          <el-table-column
            prop="balance"
            :label="$t('common.balanceWithYuan')"
            min-width="120px"
            :formatter="formatToYuan"
          ></el-table-column>
          <el-table-column
            prop="payType"
            :label="$t('common.rechargeMethod')"
            min-width="100px"
            :formatter="formatToEmpty"
          ></el-table-column>
          <el-table-column
            prop="thirdFlowNo"
            :label="$t('common.serialNo')"
            min-width="100px"
            :formatter="formatToEmpty"
          ></el-table-column>
          <el-table-column :label="$t('common.orderNo')" min-width="100px">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.orderNo"
                type="text"
                @click="goToOrderDetailPage(row)"
                >{{ row.orderNo }}</el-button
              >
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operatorName"
            :label="$t('common.operator')"
            min-width="120px"
            :formatter="formatToEmpty"
          ></el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('common.remark')"
            min-width="140px"
            :formatter="formatToEmpty"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="page-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getMallFinancialData"
          :current-page="listInfo.pageNum"
          :page-size="listInfo.pageSize"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="fileDialog" width="500px">
      <div>{{ $t('common.exportProcessing') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="button-medium"
          style="padding: 7px 30px; font-size: 12px"
          @click="fileDialog = false"
          type="info"
          >{{ $t('common.close') }}</el-button
        >
        <el-button
          class="button-medium"
          style="padding: 0px 30px; font-size: 12px"
          type="primary"
          @click="goDownload"
          >{{ $t('common.confirm') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import * as toolApi from "@/apis/tool";
import * as financialApi from "@/apis/financial";
import { formatToYuan, formatToEmpty, formatToLabel } from "@/utils/formatters";
import { getBaseURL, getWebURL } from "@/utils/util";
import { mallRechargeTypeDict, mallExpenditureTypeDict } from "@/data/dicts";
import { translateByDict } from "@/utils/translators";
export default {
  name: "mallRecharge",
  props: {
    tableHeight: {
      type: Number,
      default: 0,
    },
    index: {
      type: String,
    },
  },
  data() {
    return {
      mallRechargeTypeDict,
      mallExpenditureTypeDict,
      formatToYuan,
      formatToEmpty,
      formatToLabel,
      fileDialog: false,
      listInfo: {
        recordType: "",
        type: "",
        productType: "",
        bizType: "",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        date: [
          moment().subtract(30, "d").format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
        gmtCreateBegin: moment().subtract(30, "d").format("YYYY-MM-DD 00:00:00"),
        gmtCreateEnd: moment().format("YYYY-MM-DD 23:59:59"),
      },
      listData: [],
      listLoading: false,
      downloadLoading: false,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          // time.getTime()获取的是时间戳
          // 只能选择365天的范围且不能大于当前日期
          const choiceDateTime = new Date(this.selectDate).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 1
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 1
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后12个月时间可选,后12个月最大为当前日期
          if (this.selectDate) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
    };
  },
  mounted() {
    this.getMallFinancialData();
  },
  methods: {
    goDownload() {
      this.fileDialog = false;
      window.open(getWebURL("visa") + "/downloadPage");
      // location.href = getWebURL("visa") + "/downloadPage";
    },
    async getDownloadList() {
      try {
        const result = await toolApi.listDownloadList({
          pageNum: 1,
          pageSize: 100,
        });
        if (result.records && result.records.length > 0) {
          let count = 0;
          result.records.forEach((item) => {
            if (item.status == "DOING") {
              count = count + 1;
            }
            if (item.status == "SUCCESS" && item.downloadStatus == 0) {
              count = count + 1;
            }
          });
          setTimeout(() => {
            this.setDownloadNum(count);
          }, 100);
        }
      } catch (e) {
        console.log(e, "e");
      }
    },
    async download() {
      console.log(this.listInfo, "list");
      if (!this.listInfo.date || this.listInfo.date.length == 0) {
        return this.$message.error(this.$t('common.selectDate'));
      }
      this.downloadLoading = true;
      try {
        let filterPararms = _.cloneDeep(this.listInfo);
        const result = await financialApi.recordExport(filterPararms);
        this.downloadLoading = false;
        if (result) {
          this.fileDialog = true;
          this.getDownloadList();
          // window.open(getBaseURL("api") + result);
        }
      } catch (err) {
        this.downloadLoading = false;
        throw new Error(err);
      }
    },
    handleDateChange(value) {
      if (value && value[0] && value[1]) {
        this.listInfo.gmtCreateBegin = value[0];
        this.listInfo.gmtCreateEnd = value[1];
      } else {
        // this.pickerMinDate = "";
        this.listInfo.gmtCreateBegin = "";
        this.listInfo.gmtCreateEnd = "";
      }
    },
    async getMallFinancialData(pageNum = 1) {
      this.listLoading = true;
      try {
        this.listInfo.pageNum = pageNum;
        const params = _.cloneDeep(this.listInfo);

        if (params.type) {
          const [productType, ...type] = String(params.type).split("");
          params.productType = productType;
          if (productType === "0") {
            params.bizType = type.join("");
            params.serviceType = "";
          } else if (productType === "1" || productType === "3") {
            params.bizType = "";
            params.serviceType = params.type;
          } else if (productType === "5") {
            params.bizType = "";
            params.serviceType = params.type;
          } else {
            params.bizType = "";
            params.serviceType = "";
          }
          params.type = "";
        }

        const result = await financialApi.getMallFinancialData(params);
        this.listLoading = false;

        if (result) {
          const { records, pageNum, totalCount } = result;
          this.listData = records || [];
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          };
        }
      } catch (err) {
        this.listLoading = false;
        throw new Error(err);
      }
    },
    resetSearch() {
      const gmtCreateBegin = moment().subtract(30, "d").format("YYYY-MM-DD");
      const gmtCreateEnd = moment().format("YYYY-MM-DD");
      this.listInfo = {
        recordType: "",
        type: "",
        productType: "",
        bizType: "",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        date: [gmtCreateBegin, gmtCreateEnd],
        gmtCreateBegin,
        gmtCreateEnd,
      };
      this.$refs.searchForm.clearValidate();
      this.getMallFinancialData();
    },
    async goToOrderDetailPage({ orderNo, productType }) {
      let url = "";
      switch (productType) {
        case 1:
          url =
            getWebURL("platform") +
            "/web/mall?path=/airport-service/order/detail/" +
            orderNo;
          break;
        case 2:
          url =
            getWebURL("platform") + "/web/mall?path=/insurance/order/detail/" + orderNo;
          break;
        case 3:
        case 4: {
          const result = await toolApi.getSchengenOrderIdByOrderNo(orderNo);
          url = getWebURL("visa") + "/booking-detail/" + result.orderId;
          break;
        }
      }
      window.open(url);
    },
    getTypeName({ productType, bizType, serviceType }) {
      if (this.listInfo.recordType == 1) {
        let type = "";
        if (productType === 0) {
          type = "0" + bizType;
        } else if (productType === 1 || productType === 3) {
          type = serviceType;
        } else if (productType === 5) {
          type = serviceType;
        } else if (productType === 6) {
          type = serviceType;
        } else {
          type = productType;
        }
        console.log(type, "type");
        return translateByDict(type.toString(), mallRechargeTypeDict, "code", "name");
      } else {
        let type = "";
        if (productType === 0) {
          type = 0;
        } else if (productType === 1 || productType === 3) {
          type = serviceType;
        } else if (productType === 5) {
          type = serviceType;
        } else {
          type = productType;
        }
        return translateByDict(type.toString(), mallExpenditureTypeDict, "code", "name");
      }
    },
  },
};
</script>
